




import { computed, defineComponent } from '@vue/composition-api';
const name = 'ttam-basic-skeleton';
export default defineComponent({
  name,
  props: {
    width: {
      type: String,
      default: '',
    },
    height: {
      type: String,
      default: '',
    },
  },
  setup(props) {
    const style = computed(() => {
      const widthStyle = props.width ? `width: ${props.width};` : '';
      const heightStyle = props.height ? `height:${props.height};` : '';

      return `${widthStyle}${heightStyle}`;
    });

    return {
      style,
      name,
    };
  },
});
